<template>


        <div id="not-collected" :class="'accordion-section'+ (problem.open?' active':'')" v-if="problem.data">
          <div class="accordion-header"  @click="problem.open = !problem.open">
            <div class="accordion-title">
              <i :class="'bi '+ problem.ico"></i> {{ problem.name }}
              <span :class="'accordion-badge ' + (problem.count <= 0?'success':problem.count<2?'info':problem.count<20?'warning':'critical')">{{ problem.count }} задач</span>
            </div>
            <div class="accordion-icon">▼</div>
          </div>
          <div :class="'accordion-content'+ (problem.open?' active':'')">
            <template v-if="problem.data.oldest_not_collected">
            <div class="alert-box">
              ⚠️ Внимание! {{ problem.data.not_collected_count }} задач(и) не собраны более 2 часов.
            </div>
            <table class="data-table">
              <thead>
              <tr>
                <th>ID</th>
                <th>Проект</th>
                <th>Ресурс</th>
                <th>Период</th>
                <th>Создана</th>
                <th>Возраст</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="obj in problem.data.oldest_not_collected">
                <td>{{ obj.id }}</td>
                <td>{{ obj.link__project__name }}</td>
                <td>{{ obj.link__resource__name }}</td>
                <td>{{ obj.date_start }} - {{ obj.date_end }}</td>
                <td>{{$moment(obj.date_create).format("DD.MM.YYYY HH:mm")}}</td>
                <td style="color: #e74c3c;">{{$moment(obj.date_create).fromNow()}}</td>
              </tr>
              </tbody>
            </table>
            </template>
            <div v-else class="alert-box" style="background: #d4edda; border-left-color: #27ae60;">
              ✅ Отлично! Нет зависших задач.
            </div>
          </div>
        </div>


</template>

<script>

export default {
  name: 'FreezeInfo',
  data() {
    return {}
  },
  props: {
    problem: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">

</style>